module.exports = __webpack_public_path__ + "static/studio-a-booth-2d09f13f6bcfa43260446555430bfa19.jpg";